(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bonk-entry"] && !Shopify.designMode) return;
  try {
    
(() => {
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const key='bonk-welcome-seen-v2';
 const init=(entry)=>{
  if(entry.dataset.ready)return;
  entry.dataset.ready='true';
  const dialog=entry.querySelector('[data-bonk-dialog]');
  const opener=entry.querySelector('[data-bonk-index-open]');
  if(typeof dialog.showModal!=='function')return;
  let timer;let previous;
  const cleanup=()=>{clearTimeout(timer);dialog.classList.remove('is-unveiling');document.documentElement.classList.remove('bonk-welcome-open');};
  const finish=()=>{cleanup();if(dialog.open)dialog.close();};
  const unveil=()=>{
   if(!dialog.open)return;
   if(reduced.matches){finish();return;}
   dialog.classList.add('is-unveiling');
   clearTimeout(timer);timer=setTimeout(finish,650);
  };
  const open=()=>{
   if(dialog.open)return;
   previous=document.activeElement;
   cleanup();
   dialog.showModal();document.documentElement.classList.add('bonk-welcome-open');
   try{sessionStorage.setItem(key,'true');}catch(error){}
  };
  opener.hidden=false;
  opener.addEventListener('click',open);
  entry.querySelector('[data-bonk-index-enter]').addEventListener('click',unveil);
  entry.querySelector('[data-bonk-index-skip]').addEventListener('click',finish);
  dialog.addEventListener('cancel',()=>cleanup());
  dialog.addEventListener('close',()=>{cleanup();if(previous?.isConnected&&previous!==document.body)previous.focus({preventScroll:true});});
  dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',finish));
  reduced.addEventListener('change',()=>{if(reduced.matches&&dialog.classList.contains('is-unveiling'))finish();});
  let seen=true;
  try{seen=sessionStorage.getItem(key)==='true';}catch(error){seen=true;}
  if(!seen&&entry.dataset.auto==='true'&&!window.Shopify?.designMode&&!location.hash)open();
 };
 const start=()=>document.querySelectorAll('[data-bonk-welcome]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
 document.addEventListener('shopify:section:unload',event=>{
  const entry=event.target.querySelector('[data-bonk-welcome]');
  if(entry?.querySelector('dialog')?.open){entry.querySelector('dialog').close();document.documentElement.classList.remove('bonk-welcome-open');}
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
